import { ICommentsApi } from "@app/components/kb-comments/kb-comments.component";
import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ConfiguratorHelper } from "@app/helpers/configurator.helper";
import { Dirs } from "@app/helpers/dirs";
import { ApiService } from "@app/services/api.service";
import { AuthService, IAuthService } from "@app/services/auth.service";
import { CrudService } from "@app/services/crud.service";
import { IDrawer } from "@app/services/drawer.service";
import { KbService } from "@app/services/kb.service";
import { QuoteService } from "@app/services/quote.service";
import { RuleService } from "@app/services/rule.service";
import { SfdcService } from "@app/services/sfdc.service";
import { StorageService } from "@app/services/storage.service";
import { UploadService } from "@app/services/upload.service";
import { CrudController, ICrudScope } from "@app/views/crud.view";
import { Configurator, ConfiguratorAction, DialogButton, eAlertType, eEnvironment, eFileSource, eFileStatus, eInputDialogType, eRuleType, eValidationType, eViewPermission, eViewType, eWorkflowAction, Field, IAlert, IAllowedAction, IBuildType, ICompany, ICompanyCurrency, IConfiguratorRuleArgs, IConfiguredProduct, IContact, ICustomer, IFieldUploadOptions, IKb3dCallSceneFunctionArgs, IKbFile, IKbUser, InputDialogButton, IPage, IProduct, IProductImageChangeArgs, IQuote, IQuoteFile, IQuoteHeader, IQuoteProduct, IReorderProductsArgs, ISetSceneArgs, ITranslationPackage, IUploadValue, IValidationMessage, IViewPermission, KbObject, KbObjectManager, LayoutConfig, meta, Option, OptionFilter, Page } from "@models";
import { ClientLogger, KPromise } from "@rules";
import { icons, IMessage, Utils } from "@tools";
import { StateParams } from "@uirouter/angularjs";
import * as angular from "angular";
import Big from "big.js";
import * as Q from "q";

export interface IQuotePermissions {
    canModifyName: boolean;
    canModifyCustomer: boolean;
    canModifyDiscount: boolean;
    canModifyProducts: boolean;
    canAddAttachments: boolean;
    canModifyAttachments: boolean;
    canModifyQuoteHeader: boolean;
    canModifyCurrency: boolean;
    canModifyShipping: boolean;
    canViewQuoteHeader: boolean;
    canViewDiscount: boolean;
    canViewCost: boolean;
    canViewPricing: boolean;
    canViewCustomer: boolean;
    canViewCurrency: boolean;
    canViewShipping: boolean;
    canReorderProducts: boolean;
    canModifyQuoteProductDescription: boolean;
    canViewQuoteProductDetails: boolean;
}

export interface IQuoteScope extends ICrudScope<IQuote> {
    defConfig: Configurator; // the quote header configurator
    visiblePages: IPage[];
    addProduct: () => void;
    deleteProduct: (product: IQuoteProduct) => void;
    downloadAttachment: (item: IQuoteFile) => void;
    downloadQuoteProductFile: (file: IKbFile) => void;
    extNet: (product: IQuoteProduct) => number;
    extCost: (product: IQuoteProduct) => number;
    margin: (product: IQuoteProduct) => number;
    // localPrice: (product: IQuoteProduct) => number;
    submit: () => void;
    approve: () => void;
    reject: () => void;
    revise: () => void;
    totalCost: () => Big;
    totalExtNet: () => Big;
    total: () => Big;

    upload: (file, id) => void;

    executeAction: (actionType: string, modifiedProduct?: IQuoteProduct, idCustomAction?: number) => ng.IPromise<any>;
    commentListApi: ICommentsApi;

    updateName: () => void;
    updateCustomer: () => void;
    updateCurrency: () => void;
    updateDiscount: () => void;
    updateShipping: () => void;
    updateProduct: (quoteProduct: IQuoteProduct) => void;
    updateProductDescription: (quoteProduct) => void;

    isActiveQuote: () => boolean;
    showCopyToThisQuoteBtn: (qp: IQuoteProduct) => boolean;
    showCopyToActiveQuoteBtn: (qp: IQuoteProduct) => boolean;
    showCopyToNewQuoteBtn: (qp: IQuoteProduct) => boolean;
    copyProductToThisQuote: (qp: IQuoteProduct) => ng.IPromise<any>;
    copyProductToActiveQuote: (qp: IQuoteProduct) => ng.IPromise<any>;
    copyProductToNewQuote: (qp: IQuoteProduct) => ng.IPromise<any>;


    permissions: IQuotePermissions;
    customers: ICustomer[];
    contacts: IContact[];
    currencies: ICompanyCurrency[];
    getCurrencyName: (iso: string) => string;

    isExpanded: (product: IProduct) => boolean;
    toggleExpansion: (product: IProduct, expand?: boolean) => void;

    hasFileGenerating: (product: IQuoteProduct) => boolean;
    panes: any[];
    v: any;

    validationMessages: IValidationMessage[];
    validationMessageClicked: (msg: IValidationMessage) => void;

    selectedTab: string;

    inSteelbrick: () => boolean;
    searchProducts: (query: string) => ng.IPromise<IProduct[]>;
    submitQuickAdd: (item: IProduct) => void;
    binding: { quickAddQuery?: string };

    productSortableOptions: JQueryUI.SortableOptions;

    /*configurator scope properties*/
    selectedPageId: string;
    runFieldAction: (field: Field) => void;
    runAction: (action: ConfiguratorAction) => ng.IPromise<any>;
    fieldValueChange: (field: Field) => ng.IPromise<any>;
    /** autocomplete field controls asking for updated data */
    autoCompleteQuery: (query: string, field: Field) => ng.IPromise<Option[]>;
    /** needed for autocompletes that are using the label field to load the initial label to show */
    autoCompleteGetLabel: (value: any, field: Field) => ng.IPromise<string>;
    showFixedPrice: () => boolean;

    openGoalPriceDialog: (product?: IQuoteProduct) => void;

    translateKbo: (o: KbObject, prop: string) => string;
    infiniteScroll: () => void;
    productsInView: IQuoteProduct[];

    availableProductBuildTypes: IBuildType[];
    productBuildTypes: any;
    getAvailableProductBuildTypes: (product: IQuoteProduct) => IBuildType[];
    buildProduct: (product: IQuoteProduct, idBuildType: number) => void;
}

export interface IRejectDialogScope extends ng.IScope {
    model?: IRejectDialogModel;
    reasons?: string[];
}
export interface IRejectDialogModel {
    reason?: string;
    notes?: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IQuoteResolve {

}

export class QuoteHeaderRuleArgs implements IConfiguratorRuleArgs {
    constructor(private ctrl: QuoteController) {
        this.isMobile = ctrl.$rootScope.windowWidth < Utils.MOBILE_WIDTH;
        this.windowWidth = ctrl.$rootScope.windowWidth;
        this.windowHeight = ctrl.$rootScope.windowHeight;
    }

    public company: ICompany;
    public configurator: Configurator;
    public layoutConfig: LayoutConfig;
    public user: IKbUser;
    public kom: KbObjectManager;
    public parentKom: KbObjectManager;
    public changedField: Field;
    public selectedPage: Page;
    public environment: string;
    public baseUrl: string;
    public parameters: any;
    public clientLanguage: string;
    public logs: ClientLogger;
    public quote: IQuote;
    public isMobile: boolean;
    public windowWidth: number;
    public windowHeight: number;

    public getTables(args) {
        return new KPromise(args.ids.map(tid => this.ctrl.helper.tableArraysDb[tid]));
    }

    public sendMessage(msg: IMessage) {
        // send message to embed consumer
        Utils.sendMessageToParent({ name: msg.name, data: msg.data });

        this.ctrl.sfdcService.sendMessage(msg);
    }
    public convertCurrency(obj) {
        return this.ctrl.kbService.fxConvertAsync(obj.amount, obj.currencyCode);
    }

    public callSafeFunction(obj) {
        return this.ctrl.api.safeFunctions.run(obj.safeFunctionId, obj.parameters, this.ctrl.$rootScope.contentTracker);
    }
    public generateNumber(args) {
        return this.ctrl.api.generators.next(args.generatorId, this.ctrl.$rootScope.contentTracker);
    }
    public selectPage(page) {
        this.ctrl.$scope.selectedPageId = page.id;
    }
    public navigateToElement(elem) {
        let page = elem.findAncestor(kbo => kbo instanceof Page) as Page;
        if (page && page.visible) {
            this.ctrl.$scope.selectedPageId = page.id;
        }
    }
    public nextPage(){
        let selectedPage = this.configurator.$manager.get<Page>(this.ctrl.$scope.selectedPageId, false);
        if (selectedPage){
            let index = this.configurator.pages.indexOf(selectedPage);
            if (index >= 0 && index < this.configurator.pages.length - 1 ){
                this.ctrl.$scope.selectedPageId = this.configurator.pages[index + 1].id;
            }
        }
    }
    public backPage(){
        let selectedPage = this.configurator.$manager.get<Page>(this.ctrl.$scope.selectedPageId, false);
        if (selectedPage){
            let index = this.configurator.pages.indexOf(selectedPage);
            if (index >= 0 && index > 0){
                this.ctrl.$scope.selectedPageId = this.configurator.pages[index - 1].id;
            }
        }
    }
    public upload() { return this.ctrl.$q.when<string>(null); }
    public runSceneAction(name) { return this.ctrl.$q.when(null); }
    public callSceneFunction(args: IKb3dCallSceneFunctionArgs){return this.ctrl.$q.when(null);}
    public setScene(args: ISetSceneArgs) { return this.ctrl.$q.when(null); }
    public runNamingRule() { return this.ctrl.$q.when(null); }
    public addNestedConfigurator(idProduct, idParent, name?: string) { return this.ctrl.$q.when<Configurator>(null); }
    public copyNestedConfigurator(nested: Configurator | string, idParent, name?: string) { return this.ctrl.$q.when<Configurator>(null); }
    public setNumberOfNestedConfigurators(idProduct, idParent, n) { return this.ctrl.$q.when(null); }
    public removeNestedConfigurator(nested: Configurator | string) { return this.ctrl.$q.when(null); }
    public showPriceDetails() { }
    public alert(args: IAlert) { this.ctrl.dialogService.alert(args); }
    public getOptionFilterSource(idOptionFilter: string, fromConfigurator?: Configurator) {
        fromConfigurator = fromConfigurator || this.configurator;
        let f = fromConfigurator.$manager.get(idOptionFilter) as OptionFilter;
        return new KPromise(f ? f.$source : []);
    }
    public setLayoutSetting(id: string, value: any) {}
    public getLayoutSetting(id: string) { }
    public runConfiguredProduct(cp: IConfiguredProduct) { }
}

@NgView({
    token: Token.QuoteView,
    inherit: [Token.CrudView],
    dependencies: [
        Token.Header,
        Token.QuoteService,
        Token.SfdcService,
        Token.RuleService,
        Token.$Filter,
        Token.$Timeout,
        Token.$Interval,
        Token.$Location,
        Token.UploadService,
        Token.KbService,
        Token.StorageService
    ],
    resolves: [
        {
            name: "model",
            dependencies: [
                Token.$StateParams,
                Token.AuthService,
                Token.QuoteService
            ],
            fn: (
                $stateParams: StateParams,
                authService: IAuthService,
                quoteService: QuoteService
            ) => {
                return authService.authPromise.then(() => {
                    if ($stateParams.id) {
                        return quoteService.getQuoteById($stateParams.id);
                    } else {
                        return quoteService.getNewQuote();
                    }
                });
            }
        },
        {
            name: "header",
            dependencies: [
                Token.AuthService,
                Token.ApiService
            ],
            fn: (
                authService: AuthService,
                api: ApiService
            ) => {
                return authService.authPromise.then(() => {
                    return api.quoteHeaders.getDefault();
                });
            }
        }
    ]
})
export class QuoteController extends CrudController<IQuote> {
    constructor(
        public $scope: IQuoteScope,
        crudService: CrudService,
        model: IQuote,
        public header: IQuoteHeader,
        public quoteService: QuoteService,
        public sfdcService: SfdcService,
        public ruleService: RuleService,
        public $filter: ng.IFilterService,
        public $timeout: ng.ITimeoutService,
        public $interval: ng.IIntervalService,
        public $location: ng.ILocationService,
        public uploadService: UploadService,
        public kbService: KbService,
        public storageService: StorageService
    ) {

        super($scope,
            crudService,
            model);

        this.bypassUnsavedConfirmation = !!model.idWorkflow;

        this.drawerService.setHelpUrl("Quotes");
        this.drawerService.pageTitle = this.$scope.model ? this.$scope.model.name : loc.newquote;
        this.drawerService.pageType = loc.quote_title;
        this.drawerService.pageIcon = icons.quote;

        $scope.v = {};
        $scope.customers = [];
        $scope.contacts = [];
        $scope.currencies = [];
        $scope.validationMessages = [];
        $scope.binding = {};
        $scope.selectedTab = "tab_basic";
        $scope.productsInView = [];
        $scope.productBuildTypes = {};
        /*$rootScope.$on(events.loginSuccessful, () =>
        {
            this.subscribe().finally(() =>
            {
                if (this.submitQuotePending) {
                    this.submitQuotePending = false;
                    this.dialogService.confirm("Would you like to continue submitting your quote?", () =>
                    {
                        this.submit();
                    });
                }
            });
        });*/

        let thisCtrl = this;
        $scope.upload = function(file, field) {
            let uploadOptions = {
                convertPdfToImage: field.convertUploadPdfToImage
            } as IFieldUploadOptions;
            return thisCtrl.uploadService.uploadQuoteFile(file, uploadOptions).then(uuid => {
                let uploadValue = field.value as IUploadValue;
                uploadValue.path = uuid;
                // clear the asset id in case there was an old file there that was just 
                // replaced to make sure the new file is uploaded to the scene
                uploadValue.assetId = null;
                
            });
        };

        let viewType = this.$state.current.data.viewType;

        if ($scope.model) {
            this.deleteMsg = loc.msg_deleterecord.format(loc.quote_title, $scope.model.name);
        }

        this.onRelationshipEdited("Files", m => {
            this.setUpdatedModelInternal(m, false);
        });

        if (viewType == eViewType.new) {
            let idCategory = this.$location.search().idcategory;
            model = $scope.model = quoteService.getNewQuote();

            if (this.sfdcService.record() && this.sfdcService.record().Name) {
                $scope.model.name = this.sfdcService.record().Name;
            }
        }


        if (this.$rootScope.isSfdc && !this.$rootScope.isSfdcCpq) {
            quoteService.quote = this.$scope.model;
        }


        $scope.updateName = () => {
            if ($scope.model.state) {
                if (this.validate() || this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                    $scope.executeAction(eWorkflowAction.modifyName);
                }
                else {
                    this.promptUserToFixErrors();
                    this.revertToClean();
                }
            }
        }

        $scope.updateCurrency = () => {
            if ($scope.model.state) {
                if (this.validate() || this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                    $scope.executeAction(eWorkflowAction.modifyCurrency);
                } else if ($scope.model.state) {
                    this.promptUserToFixErrors();
                    this.revertToClean();
                }
            }
        };

        $scope.updateCustomer = () => {
            // update the customer name for display (when the kbAtom is not active)
            let customer = $scope.customers.find(c => c.id == $scope.model.idCustomer);
            $scope.model.customer = customer ? customer.name : null;
            let contact = $scope.contacts.find(c => c.id == $scope.model.idContact);
            $scope.model.contact = contact ? contact.name : null;

            if ($scope.model.state) {
                if (this.validate() || this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                    $scope.executeAction(eWorkflowAction.modifyCustomer);
                } else if ($scope.model.state) {
                    this.promptUserToFixErrors();
                    this.revertToClean();
                }
            }
        };

        $scope.updateDiscount = () => {
            if ($scope.model.state) {
                if (this.validate() || this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                    $scope.executeAction(eWorkflowAction.modifyDiscount);
                } else if ($scope.model.state) {
                    this.promptUserToFixErrors();
                    this.revertToClean();
                }
            }
        };

        $scope.updateShipping = () => {
            if ($scope.model.state) {
                if (this.validate() || this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                    $scope.executeAction(eWorkflowAction.modifyShipping);
                } else if ($scope.model.state) {
                    this.promptUserToFixErrors();
                    this.revertToClean();
                }
            }
        };

        $scope.updateProduct = quoteProduct => {
            if (this.validate() || this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                if ($scope.model.idWorkflow || quoteProduct.requiresUpdate) {
                    // we are in a workflow so we need to run the action OR we need to update
                    // the product to re - run it's pricing rule (if it uses the qtyInQuote variable)
                    return $scope.executeAction(eWorkflowAction.modifyProducts, quoteProduct);
                }
            } else if ($scope.model.state) {
                this.promptUserToFixErrors();
                this.revertToClean();
            }
        };

        $scope.updateProductDescription = quoteProduct => {
            if (this.validate()) {
                if ($scope.model.idWorkflow || quoteProduct.requiresUpdate) {
                    // we are in a workflow so we need to run the action OR we need to update the product
                    // to re - run it's pricing rule (if it uses the qtyInQuote variable)
                    return $scope.executeAction(eWorkflowAction.modifyQuoteProductDescription, quoteProduct);
                }
            }
        };

        if (!$scope.model.discountPercentage) $scope.model.discountPercentage = 0;


        $scope.getAvailableProductBuildTypes = (product: IQuoteProduct) => {
            let result = [];

            if (product.isConfigured && this.$scope.productBuildTypes[product.idProduct]) {
                result = $scope.availableProductBuildTypes.filter(b => this.$scope.productBuildTypes[product.idProduct].contains(b.id));
            }

            return result;
        }

        $scope.buildProduct = (product: IQuoteProduct, idBuildType: number) => {
            this.api.quotes.buildQuoteProduct(this.$scope.model.id, product.id, idBuildType).then(q => {
                this.handleActionResponse(q, eWorkflowAction.buildQuoteProduct);
                this.dialogService.alert({
                    type: eAlertType.success,
                    persist: false,
                    msg: loc.quoteproductbuilding
                });
            });
        }

        $scope.commentListApi = {
            refresh: () => {

            }
        };

        $scope.downloadQuoteProductFile = (file: IKbFile) => {
            this.$window.open("/api/quotes/productfile/download/" + file.id, "_blank");
        };

        $scope.addProduct = () => {
            this.validate();
            if (!this.$scope.model.name) return;
            // save the current quote
            quoteService.quote = $scope.model;
            $scope.executeAction(eWorkflowAction.save).then(() => {
                this.bypassUnsavedConfirmation = true;
                this.$state.go("kb.products");
            });
        };

        let expandedProducts = {};

        $scope.isExpanded = product => {
            return expandedProducts[product.id];
        };

        $scope.toggleExpansion = (product, expand) => {
            if (expand == null) {
                expandedProducts[product.id] = !expandedProducts[product.id];
            } else {
                expandedProducts[product.id] = expand;
            }
        };

        $scope.downloadAttachment = (item: IQuoteFile) => {
            if (item.source == eFileSource.media) {
                window.open(storageService.getMediaUrl(item.filePath));
            } else {
                window.open("api/quotes/file/download/" + item.id, "_blank");
            }
        };

        $scope.hasFileGenerating = product => {
            return product.files && product.files.some(f => f.status == eFileStatus.generating);
        };

        $scope.deleteProduct = (product: IQuoteProduct) => {
            this.dialogService.dialog({
                content: loc.msg_deletequoteproduct.format(product.name),
                buttons: [
                    new DialogButton(loc.ok, icons.success, args => {
                        let promise: ng.IPromise<any> = this.$q.when(true);
                        if (!this.$scope.model.idWorkflow) {
                            promise = this.$scope.executeAction(eWorkflowAction.save);
                        }
                        return promise.then(() => {
                            return this.api.quotes.deleteQuoteProduct($scope.model.id, product, this.$rootScope.contentTracker).then(r => {
                                this.handleActionResponse(r, eWorkflowAction.modifyProducts);
                            });
                        });
                    }),
                    new DialogButton(loc.cancel, icons.cancel, args => {

                    })
                ]
            });
        };

        $scope.isActiveQuote = () => {
            return quoteService.quote != null && $scope.model.id == quoteService.quote.id;
        };

        $scope.showCopyToActiveQuoteBtn = (qp) => {
            /** only show this 'copy to active quote' button if we are not in the active quote, and the active quote allows modifying products */
            return (
                qp.isConfigured
                && !$scope.isActiveQuote() //this quote is not the active quote
                && quoteService.quote
                && quoteService.canModifyProductsOfQuote(quoteService.quote)
                && !this.$rootScope.isSfdc //this should never happen in CRM integration
            );
        };

        $scope.showCopyToThisQuoteBtn = (qp) => {
            /** only show 'copy to this quote' button if this quote has modify products permissions */
            return (
                qp.isConfigured
                && $scope.permissions.canModifyProducts
            );
        };

        $scope.showCopyToNewQuoteBtn = (qp) => {
            return qp.isConfigured && !this.$rootScope.isSfdc; //creating a new quote in this way would break the CRM integration
        }

        $scope.copyProductToThisQuote = (qp) => {
            this.quoteService.quote = this.$scope.model; //make this the active quote
            let copyProduct = () => {
                return quoteService.copyProductToActiveQuote(qp.id).then(r => {
                    if (quoteService.quote && quoteService.quote.id == $scope.model.id) {
                        this.$state.reload();
                    } else {
                        quoteService.goToQuote();
                    }
                });
            };
            if (!this.$scope.model.idWorkflow && !this.modelIsClean()) {
                return this.$scope.executeAction(eWorkflowAction.save).then(copyProduct);
            }
            else {
                return copyProduct();
            }
        };

        $scope.copyProductToActiveQuote = (qp) => {
            return quoteService.copyProductToActiveQuote(qp.id).then(r => {
                if (quoteService.quote && quoteService.quote.id == $scope.model.id) {
                    this.$state.reload();
                } else {
                    quoteService.goToQuote();
                }
            });
        };

        $scope.copyProductToNewQuote = (qp) => {
            return quoteService.copyProductToNewQuote(qp.id).then(r => {
                quoteService.goToQuote();
            });
        };

       

        // $scope.delete = () => {
        //     return this.delete().then(() => {
        //         // if the quote we're deleting is the active quote, clear it out of the quoteservice
        //         if (quoteService.quote && quoteService.quote.id == $scope.model.id) {
        //             quoteService.quote = undefined;
        //         }
        //     });
        // };

        $scope.extNet = product => {
            let discount = product.discountPercentage || 0;
            let volumeDiscount = 0;
            let volumeDiscounts = product.volumeDiscounts.sort((vd1, vd2) => vd1.qty - vd2.qty);
            for (var key in volumeDiscounts) {
                let vd = volumeDiscounts[key];
                if (vd.qty > product.qty) break;
                volumeDiscount = vd.disc;
            }
            let nonfixed = Big(product.price).minus(Big(product.fixedPrice)).times(Big(product.qty));
            let ext = nonfixed.plus(Big(product.fixedPrice));
            let extNet: any = ext.minus(ext.times(Big(discount).div(100))).minus(ext.times(Big(volumeDiscount).div(100)));

            return extNet;
        };

        $scope.margin = product => {
            return $scope.extNet(product) - $scope.extCost(product);
        }

        $scope.extCost = product => {
            let extCost: any = Big(product.cost)
                .minus(Big(product.fixedCost))
                .times(product.qty)
                .plus(Big(product.fixedCost));
            return extCost;
        };

        let sum = (mapFn: (product: IQuoteProduct) => number): Big => {
            let products = $scope.model.products;

            let total = products.reduce((previousValue: Big, currentValue: IQuoteProduct, index: number) => {
                let product = products[index];
                let propValue = mapFn(product);
                return previousValue.plus(Big(propValue));
            }, Big(0));

            return total as Big;
        };

        $scope.totalCost = () => {
            return sum(product => $scope.extCost(product));
        };

        $scope.totalExtNet = () => {
            return sum(product => $scope.extNet(product));
        };

        $scope.total = () => {
            let extNet = $scope.totalExtNet();
            let discount = $scope.model.discountPercentage || 0;
            let shipping = $scope.model.shipping || 0;
            return extNet.minus(extNet.times(Big(discount).div(100))).plus(Big(shipping));
        };

        $scope.showFixedPrice = () => {
            return $scope.model.products.some(p => p.fixedPrice != 0);
        };

        $scope.openGoalPriceDialog = (product?: IQuoteProduct) => {
            let value = Math.round(Number(product ? product.price : $scope.total()) * 100) / 100;
            let undiscountedValue = (product ? product.price : $scope.totalExtNet());
            this.dialogService.input({
                inputType: eInputDialogType.text,
                value: value,
                msg: "Please enter the desired goal price for " + (product ? "each " + product.name : "this quote") + ".",
                buttons: [
                    new InputDialogButton(loc.ok, icons.success, args => {
                        let discount = Number(Big(args.value).div(undiscountedValue));
                        discount = Math.round((1 - discount) * 10000) / 100;
                        if (product) {
                            product.discountPercentage = discount;
                        }
                        else {
                            $scope.model.discountPercentage = discount;
                        }
                    }),
                    new InputDialogButton(loc.cancel, icons.cancel, args => {
                    })
                ]
            });
        }

        $scope.panes = [
            { title: "General", content: "general", disabled: false },
            { title: "Comments", content: "comments", disabled: false },
            { title: "History", content: "history", disabled: false }];

        $scope.inSteelbrick = () => {
            return (this.sfdcService.record() && this.sfdcService.record().attributes.type == "SBQQ__Quote__c");
        };

        $scope.searchProducts = (query: string): ng.IPromise<IProduct[]> => {
            if (!query) {
                return Q.resolve([]);
            }
            return this.api.products.searchByCategory({
                query,
                skip: 0,
                take: 11,
                filters: [
                    {
                        property: meta.Product.isConfigured.name,
                        values: [false]
                    }
                ]
            });
        };

        $scope.submitQuickAdd = (item: IProduct) => {
            if (!item) return;
            this.$scope.binding.quickAddQuery = "";

            let addProduct = () => {
                this.quoteService.quote = this.$scope.model;
                this.quoteService.addProduct({
                    qty: 1,
                    configuredProduct: null,
                    idProduct: item.id,
                    addLocally: false
                }).then(() => {
                    this.setUpdatedModelInternal(this.quoteService.quote, false);
                });
            };

            if (this.$scope.model.name) {
                if (this.$scope.model.id) {
                    addProduct();
                } else {
                    this.$scope.executeAction(eWorkflowAction.save).then(addProduct);
                }
            }
        };

        $scope.productSortableOptions = {
            stop: (e, ui) => {
                if (this.$scope.permissions.canReorderProducts && this.validate()) {
                    // set product order
                    for (let i = 0; i < $scope.model.products.length; i++) {
                        $scope.model.products[i].order = i;
                    }
                    //reset the products in view
                    this.$scope.productsInView = [];
                    this.$scope.infiniteScroll();
                    if ($scope.model.idWorkflow) { // we are in a workflow so we need to run the action
                        this.$timeout(() => {
                            return $scope.executeAction(eWorkflowAction.reorderProducts);
                        }, 0);
                    }
                } else {
                    // $(".kb-quote__ops").sortable("cancel");
                }
            },
            disabled: true,
            handle: ".kb-grip"
        };

        $scope.executeAction = (
            actionType: string,
            modifiedProduct: IQuoteProduct = null,
            idCustomAction: number = 0
        ): ng.IPromise<any> => {
            let data;
            let url = "/api/quotes/" + actionType;
            let method = "POST";
            let getDataDeferred = this.$q.defer();

            if (!this.validate() && !this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow &&
                actionType != eWorkflowAction.reject &&
                actionType != eWorkflowAction.save &&
                actionType != eWorkflowAction.deleter) {

                this.promptUserToFixErrors();
                return;
            }

            if (!$scope.model.externalId &&
                this.sfdcService.record() &&
                this.sfdcService.record().attributes.type == "KBMAX__Quote__c"
            ) { // add the externalId to the quote
                $scope.model.externalId = this.sfdcService.record().Id;
            }
            $scope.model.headerValues = $scope.defConfig.getConfiguredProduct();
            

            if (actionType == eWorkflowAction.save) {
                data = $scope.model;
                getDataDeferred.resolve();
            } else if (actionType == eWorkflowAction.custom) {
                data = { idQuote: $scope.model.id, idCustomAction };
                getDataDeferred.resolve();
            } else if (actionType == eWorkflowAction.reject) {
                // build up a scope to drive the dialog ui
                let dialogScope: IRejectDialogScope = $scope.$new(true);
                dialogScope.model = {
                    reason: loc.other,
                    notes: ""
                };
                dialogScope.reasons = $scope.model.rejectedReasons;

                this.dialogService.dialog({
                    template: Dirs.view("dialog-reject"),
                    scope: dialogScope,
                    buttons: [
                        new DialogButton(loc.continuer, icons.success, args => {
                            data = {
                                quote: $scope.model,
                                reason: dialogScope.model.reason,
                                notes: dialogScope.model.notes
                            };
                            getDataDeferred.resolve();
                        }),
                        new DialogButton(loc.cancel, icons.cancel, args => { })
                    ]
                });
            } else if (actionType == eWorkflowAction.modifyProducts) {
                url = "/api/quotes/" + this.$scope.model.id + "/product/" + modifiedProduct.id;
                method = "PUT";
                data = modifiedProduct;
                getDataDeferred.resolve();
            } else if (actionType == eWorkflowAction.modifyQuoteProductDescription) {
                url = "/api/quotes/" + this.$scope.model.id + "/product/" + modifiedProduct.id + "/description";
                method = "PUT";
                data = modifiedProduct;
                getDataDeferred.resolve();
            } else if (actionType == eWorkflowAction.reorderProducts) {
                url = "/api/quotes/reorderproducts";
                method = "POST";
                data = {
                    id: this.$scope.model.id,
                    products: this.$scope.model.products.map(qp => {
                        return { id: qp.id, order: qp.order };
                    })
                } as IReorderProductsArgs;
                getDataDeferred.resolve();
            } else {
                data = $scope.model;
                getDataDeferred.resolve();
            }

            return getDataDeferred.promise.then(() => {
                return this.$http<IQuote>({
                    method,
                    url,
                    data,
                    tracker: this.$rootScope.contentTracker
                }).then(response => {
                    return this.handleActionResponse(response.data, actionType);
                });
            });
        };

        $scope.runFieldAction = field => {
            return this.helper.runRuleContainerAsync(field)
                .then(() => this.runRuleCycleUnit(field.$parentConfigurator, null))
                .then(() => {
                    if (this.$scope.model.idWorkflow) {
                        return this.$scope.executeAction(eWorkflowAction.modifyQuoteHeader);
                    }
                });
        };

        $scope.runAction = action => {
            return this.helper.runRuleContainerAsync(action)
                .then(() => this.runRuleCycleUnit(action.$parentConfigurator, null));
        };
        $scope.fieldValueChange = field => {
            return this.helper.runRuleContainerAsync(field)
                .then(() => this.runRuleCycleUnit(field.$parentConfigurator, field))
                .then(() => {
                    if (this.$scope.model.idWorkflow) {
                        return this.$scope.executeAction(eWorkflowAction.modifyQuoteHeader);
                    }
                });
        };
        $scope.autoCompleteQuery = (query, field) => {
            return this.helper.autoCompleteQuery(query, field);
        };
        $scope.autoCompleteGetLabel = (value, field) => {
            return this.helper.autoCompleteGetLabel(value, field);
        };
        $scope.getCurrencyName = iso => {
            let cc = $scope.currencies.find(c => c.currency.isEqual(iso));
            return cc ? `${cc.name} (${cc.currency})` : iso;
        };
        $scope.validationMessageClicked = msg => {

        };
        $scope.translateKbo = (o, prop) => {
            if (o) {
                if (this.$rootScope.companySettings.defaultLanguage != this.$rootScope.clientLanguage) {
                    if (this.translationDb.hasOwnProperty(o.id) && this.translationDb[o.id].hasOwnProperty(prop)) {
                        return this.translationDb[o.id][prop];
                    }
                }
                let realProp = prop == "name" ? "$label" : prop;
                return o[realProp];
            }
            return "";
        };

        $scope.infiniteScroll = () => {
            let pageSize = 30;
            let totalCount = $scope.model.products.length;
            let currCount = $scope.productsInView.length;
            if (totalCount > currCount) {
                $scope.productsInView.pushArray($scope.model.products.slice(currCount, currCount + pageSize));
            }
        };

        this.refreshPermissions();

        this.helper = new ConfiguratorHelper({
            $http: this.$http,
            $q: this.$q,
            api: this.api,
            dialogService: this.dialogService,
            ruleService: this.ruleService,
            tracker: this.$rootScope.contentTracker,
            $rootScope: this.$rootScope,
            getRuleArgs: (c, f) => this.getRuleArgs(c, f),
            showErrors: () => (this.$rootScope.environment != eEnvironment.prod)
        });

        this.refreshDrawers();

        this.setupQuoteHeader();

        this.validate();

        this.startConfigurator();

        $scope.$on("$destroy", () => {
            this.stopValidationTimer();
        });

        // currencies
        this.api.currencies.companyOptions().then(r => {
            $scope.currencies = r;
        });

        let updateCustomers = () => {
            this.api.customers.search({
                fields: ["id", "name"],
                sortField: "name"
            }).then(r => $scope.customers = r);
        };

        let updateContacts = () => {
            if ($scope.model.idCustomer) {
                this.api.contacts.search({
                    filters: [{
                        property: "idCustomer",
                        values: [$scope.model.idCustomer]
                    }]
                }).then(r => $scope.contacts = r);
            } else {
                $scope.contacts.clear();
            }
        };



        if (this.$rootScope.companySettings.enableCustomersAndContacts && (this.$scope.permissions.canViewCustomer || this.$scope.permissions.canModifyCustomer)) {
            updateCustomers();
        }

        $scope.$watch("model.idCustomer", (newValue, oldValue) => {
            updateContacts();
        });

        this.$scope.infiniteScroll(); //fill in first set of products
        this.startValidationTimer();

        if (this.$scope.isNew && this.$rootScope.isSfdc && !this.$rootScope.isSfdcCpq) {
            let canvasParams = this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters;
            if (canvasParams.autoSubmit != null && (canvasParams.autoSubmit == true || canvasParams.autoSubmit.isEqual("true"))) {
                this.submit();
            } else {
                this.$scope.executeAction(eWorkflowAction.save);
            }
        }
    }

    private submitQuotePending: boolean;
    public helper: ConfiguratorHelper;
    public translationDb: { [id: string]: ITranslationPackage } = {};
    private _stopValidationTimer: ng.IPromise<any>;
    public productImageChange: (args: IProductImageChangeArgs) => void;

    public client(api: ApiService) {
        return api.quotes;
    }

    public onSuccess() {
        this.$state.go("kb.quoteEdit", { id: this.$scope.model.id });
        this.drawerService.pageTitle = this.$scope.model.name;
        // this.registerWebSocket();
    }

    public onDelete() {
        // if the quote we're deleting is the active quote, clear it out of the quoteservice
        if (this.quoteService.quote && this.quoteService.quote.id == this.$scope.model.id) {
            this.quoteService.quote = undefined;
        }
        this.$state.go("kb.quotes");
    }

    public webSocketEntityType() {
        return "Quote";
    }

    public subscribe() {
        super.subscribe();
        this.signalrService.on("productImageChange", this.productImageChange = (args: IProductImageChangeArgs) => {
            if (args.idQuote == this.$scope.model.id) {
                this.$timeout(() => {
                    let product = this.$scope.model.products.find(p => p.id == args.idQuoteProduct);
                    if (product) product.imagePath = args.imagePath;
                }, 0);
            }
        });
    }

    public unsubscribe() {
        super.unsubscribe();
        this.signalrService.off("productImageChange", this.productImageChange);
    }

    protected setUpdatedModel(model: IQuote) {
        this.setUpdatedModelInternal(model);
    }

    protected setUpdatedModelInternal(model: IQuote, refreshComments: boolean = true) {
        this.$scope.model = model;
        this.refreshDrawers();
        // refresh the comments as sometimes they are added server-side (like for rejection reasons)
        if (refreshComments)
            this.$scope.commentListApi.refresh();
        this.refreshPermissions();
        this.$scope.productsInView = [];
        this.$scope.infiniteScroll();
    }

    protected setupQuoteHeader() {
        let configurator = new Configurator(new KbObjectManager(), this.header.configurator);
        configurator.$running = true;
        if (this.$scope.isEdit && this.$scope.model.headerValues) {
            configurator.runConfiguredProduct(this.$scope.model.headerValues, null);
        }

        this.$scope.defConfig = configurator;
        this.$scope.visiblePages = this.$scope.defConfig.pages.filter(p => p.visible);

        // setup translationDb
        let trans = this.header.translations.first();
        if (trans) {
            Object.keys(trans.data.objects).forEach(key => {
                this.translationDb[key] = trans.data.objects[key];
            });
        }
    }

    private refreshDrawers() {
        // TODO: This doesn't work for some reason.
        // if (this.$state.current.controller != kb.quoteController) return;
        this.drawerService.drawers.clear();
        this.$scope.availableProductBuildTypes = [];

        if (this.$scope.model.idWorkflow > 0) {
            let actions = this.$scope.model.allowedActions;
            let hasBuildProductAction = false;
            if (actions) {
                angular.forEach(actions, (action: IAllowedAction) => {
                    if (action.type == eWorkflowAction.modifyCustomer ||
                        action.type == eWorkflowAction.modifyDiscount ||
                        action.type == eWorkflowAction.modifyName ||
                        action.type == eWorkflowAction.addAttachments ||
                        action.type == eWorkflowAction.modifyAttachments ||
                        action.type == eWorkflowAction.completeBuild ||
                        action.type == eWorkflowAction.failBuild ||
                        action.type == eWorkflowAction.modifyQuoteHeader ||
                        action.type == eWorkflowAction.modifyCurrency ||
                        action.type == eWorkflowAction.reorderProducts ||
                        action.type == eWorkflowAction.modifyQuoteProductDescription ||
                        action.type == eWorkflowAction.modifyShipping) {
                        // do nothing
                    } else if (action.type == eWorkflowAction.modifyProducts) {
                        // unshift so addProducts is always at the left
                        this.drawerService.drawers.unshift({
                            icon: icons.products,
                            label: loc.addproduct,
                            visible: true,
                            command: () => {
                                // set the active quote
                                this.quoteService.quote = this.$scope.model;
                                this.$state.go("kb.products");
                            }
                        });
                    } else if (action.type == eWorkflowAction.buildQuoteProduct) {
                        this.$scope.availableProductBuildTypes.push(action.buildType);
                        hasBuildProductAction = true;
                    } else {
                        let icon = action.type == eWorkflowAction.custom ? action.icon : icons[action.type];
                        let actionName = action.type == eWorkflowAction.custom ?
                            action.name
                            : loc[action.type] || action.type;
                        this.drawerService.addDrawer(icon, actionName, () => {
                            this.$scope.executeAction(action.type, null, action.idCustomAction);
                        });
                    }
                });

                if (hasBuildProductAction) {
                    this.api.quotes.getProductBuildTypes(this.$scope.model.id).then((result) => {
                        result.value.forEach(pbt => {
                            this.$scope.productBuildTypes[pbt.idProduct] = pbt.idBuildTypes;
                        });
                    });
                }
            }
        } else {
            if (this.$scope.isEdit) {
                let drAddProduct = this.drawerService.addDrawer(icons.products, loc.addproduct, this.$scope.addProduct);
                if (!this.$rootScope.isSfdc) {
                    let drDelete = this.drawerService.addDrawer(icons.deleter, loc.deleter, this.$scope.delete);
                }
            }
            let drSave = this.drawerService.addDrawer(icons.save, loc.save, () => {
                this.validate();
                if (this.$scope.model.name) {
                    this.$scope.executeAction(eWorkflowAction.save).then(() => {
                        if (this.$state.current.data.viewType == eViewType.new &&
                            this.$rootScope.user.id == AuthService.ANONYMOUS_USER_ID
                        ) {
                            // Anonymous users need to immediately activate this newly saved quote, 
                            // since otherwise they'll not have access to it ever again.
                            this.quoteService.quote = this.$scope.model;
                        }
                    });
                }
            });
            let drSubmit = this.drawerService.addDrawer(icons.play, loc.submit, () => {
                drSubmit.disabled = true;
                this.submit();
            });
        }

        let last = this.drawerService.drawers.last();
        if (last) last.endGroup = true;

        if (this.$rootScope.isSfdc && !this.$rootScope.isSfdcCpq && this.$scope.model.externalId) {
            let drPrimary: IDrawer;
            if (this.$scope.isEdit &&
                this.sfdcService.record().KBMAX__Opportunity__c &&
                !this.sfdcService.record().KBMAX__Primary__c
            ) {
                drPrimary = this.drawerService.addDrawer(icons.approve, "Make Primary", () => {
                    let p = this.sfdcService.makePrimaryQuote(this.$scope.model);
                    this.dialogService.alert({
                        promise: p,
                        msg: "Setting " + this.$scope.model.name + " as primary quote",
                        successMsg: this.$scope.model.name +
                            " has successfully been made the primary quote of the opportunity"
                    });
                    this.refreshDrawers();
                });
                drPrimary.startGroup = true;
            }
            // add an sfdc 'out' button to take us back to the sfdc quote (or opportunity) 
            let drDone = this.drawerService.addDrawer(icons.success, loc.done, () => {
                /*if sfdc passed in a "navigateTo" id parameter, then we go there on done
                  if not, then we go to the sfdc quote object.  You can use this for example
                  to go back to the opportunity instead of the quote */
                let canvasParams = this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters;
                if (canvasParams.navigateTo != null) {
                    this.sfdcService.navigateToObject(canvasParams.navigateTo);
                } else {
                    this.sfdcService.navigateToObject(this.$scope.model.externalId);
                }
                
            });
            if (!drPrimary) drDone.startGroup = true;
        } else if (this.$rootScope.isSfdc && this.$scope.inSteelbrick()) {
            // add an sfdc 'out' button to take us back to the sfdc quote (or opportunity) 
            let drDone = this.drawerService.addDrawer(icons.success, loc.done, () => {
                this.sfdcService.sendMessage({ name: "goToSteelbrickQuote", data: this.sfdcService.record().Id });
            });
        }
    }

    private canUserPerformAction(actionType: string) {
        return this.$scope.model.allowedActions.some((a: IAllowedAction) => a.type == actionType);
    }

    public refreshPermissions() {
        if (this.$scope.model.idWorkflow) {
            this.$scope.permissions = {
                canModifyName: this.canUserPerformAction(eWorkflowAction.modifyName),
                canModifyCustomer: this.canUserPerformAction(eWorkflowAction.modifyCustomer),
                canModifyDiscount: this.canUserPerformAction(eWorkflowAction.modifyDiscount),
                canModifyProducts: this.canUserPerformAction(eWorkflowAction.modifyProducts),
                canAddAttachments: this.canUserPerformAction(eWorkflowAction.addAttachments),
                canModifyQuoteHeader: this.canUserPerformAction(eWorkflowAction.modifyQuoteHeader),
                canModifyAttachments: this.canUserPerformAction(eWorkflowAction.modifyAttachments),
                canModifyCurrency: this.canUserPerformAction(eWorkflowAction.modifyCurrency),
                canModifyShipping: this.canUserPerformAction(eWorkflowAction.modifyShipping),
                canReorderProducts: this.canUserPerformAction(eWorkflowAction.reorderProducts),
                canViewQuoteHeader: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewQuoteHeader),
                canViewDiscount: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewDiscount),
                canViewCost: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewCost),
                canViewPricing: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewPricing),
                canViewCustomer: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewCustomer),
                canViewCurrency: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewCurrency),
                canViewShipping: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewShipping),
                canModifyQuoteProductDescription: this.canUserPerformAction(eWorkflowAction.modifyQuoteProductDescription),
                canViewQuoteProductDetails: this.$scope.model.userViewPermissions.some((a: IViewPermission) =>
                    a.permission == eViewPermission.viewQuoteProductDetails)
            };
        } else {
            this.$scope.permissions = {
                canModifyName: true,
                canModifyProducts: true,
                canModifyCustomer: this.$rootScope.user.canSetQuoteCustomer,
                canModifyDiscount: this.$rootScope.user.canSetQuoteDiscount,
                canAddAttachments: this.$rootScope.user.canAddAttachments,
                canModifyAttachments: this.$rootScope.user.canModifyAllAttachments,
                canModifyShipping: this.$rootScope.user.canSetQuoteShipping,
                canModifyQuoteHeader: true,
                canModifyCurrency: this.$rootScope.user.canSetQuoteCurrency,
                canReorderProducts: true,
                canViewQuoteHeader: this.$rootScope.user.canViewQuoteHeader,
                canViewDiscount: this.$rootScope.user.canViewQuoteDiscount,
                canViewCost: this.$rootScope.user.canViewCost,
                canViewPricing: this.$rootScope.user.canViewPrices,
                canViewCustomer: this.$rootScope.user.canViewQuoteCustomer || this.$rootScope.user.canSetQuoteCustomer,
                canViewCurrency: this.$rootScope.user.canViewQuoteCurrency,
                canViewShipping: this.$rootScope.user.canViewQuoteShipping,
                canModifyQuoteProductDescription: this.$rootScope.user.canSetQuoteProductDescription,
                canViewQuoteProductDetails: true
            };
        }

        this.$scope.productSortableOptions.disabled = !this.$scope.permissions.canReorderProducts;

        if (!this.$scope.permissions.canViewQuoteHeader) {
            this.$scope.selectedTab = null;
        }
    }

    private validate(): boolean {
        let model = this.$scope.model;
        this.$scope.validationMessages = [];
        this.$scope.v.validation = {
            products: {}
        };
        let validation = this.$scope.v.validation;
        let result = true;
        if (!model.name) {
            this.$scope.validationMessages.push({
                messageType: eValidationType.error,
                message: "Quote is missing a name",
                propertyName: "name",
                object: {
                    name: "Quote"
                }
            });
            validation.name = "Please enter a name";
            result = false;
        }

        let productError = (index: number, field: string, msg: string, includeInValidationMessages: boolean = true) => {
            if (!validation.products[index]) validation.products[index] = {};
            validation.products[index][field] = msg;
            if (includeInValidationMessages) {
                this.$scope.validationMessages.push({
                    messageType: eValidationType.error,
                    message: msg,
                    propertyName: "Product " + model.products[index].name,
                    object: {
                        id: model.products[index].id.toString(),
                        name: "Product " + model.products[index].name
                    }
                });
            }
            result = false;
        };

        let getErrors = (configProd: IConfiguredProduct, name: string) => {
            if (configProd.validationMessages) {
                configProd.validationMessages.forEach(err => this.$scope.validationMessages.push(err));
            }
            if (configProd.configurators) {
                configProd.configurators.forEach(c => getErrors(c, name));
            }
        };

        model.headerValues = this.$scope.defConfig.getConfiguredProduct();

        getErrors(model.headerValues, "Header");

        model.products.forEach((product: IQuoteProduct, i: number) => {
            if (product.isConfigured && product.configuredProduct.hasErrors) {
                productError(i, "name", "Please correct the configurator errors.", false);
                getErrors(product.configuredProduct, "Product " + product.name);
            }
            if (!product.allowFractionalQty && product.qty % 1 != 0) {
                productError(i, "qty", "Must be whole number");
            }
            let maxDiscount = Math.min(product.maxDiscountPercentage, 100);
            if (product.discountPercentage > maxDiscount) {
                productError(i, "discountPercentage", "Must be less than " + maxDiscount + "%");
            }
            if (product.maxQty && product.qty > product.maxQty) {
                productError(i, "qty", "Limited to " + product.maxQty);
            }
            if ((product.minQty && product.qty < product.minQty) || product.qty < 1) {
                productError(i, "qty", "Must be at least " + Math.max(product.minQty, 1));
            }
        });

        return result &&
            (
                !model.headerValues ||
                !model.headerValues.validationMessages ||
                !model.headerValues.validationMessages.some(m => m.messageType == eValidationType.error)
            );
    }

    private submit() {
        /*if (this.$rootScope.user.id == authService.ANONYMOUS_USER_ID) {
            this.dialogService.alert({
                type: eAlertType.info,
                msg: "Before you can submit this quote, please login or register."
            });
                
            this.$rootScope.user = null;
            this.$rootScope.$broadcast(kb.events.loginRequested);
            this.submitQuotePending = true;
            return;
        }*/
        this.$scope.model.headerValues = this.$scope.defConfig.getConfiguredProduct();
        if (this.validate() ||
            this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow
        ) {
            this.$scope.executeAction(eWorkflowAction.submit).then(() => {
                this.$location.url("/quotes/" + this.$scope.model.id);
                this.bypassUnsavedConfirmation = true;
            });
        } else this.promptUserToFixErrors();
    }

    public runRuleCycleUnit(config: Configurator, field: Field, bubble = true): ng.IPromise<any> {
        // Skip the entire cycle if user can't view the quote header, since doing so is wasteful.
        if (!this.$scope.permissions.canViewQuoteHeader) return this.$q.all([]);
        let ruleArgs = this.getRuleArgs(config, field);
        let runRules =
            this.helper.runSelects(config)
                // value rules
                .then(() =>
                    this.helper.runRuleTypeAsync(config, eRuleType.value, ruleArgs)
                ).then(() =>
                    // reset $fieldsDirty of this configurator so it doesn't affect 
                    // a parent's decision on whether to run the child's rules
                    config.$fieldsDirty = false
                ).then(() =>
                    this.runValidationRule(config, ruleArgs)
                ).then(() =>
                    this.helper.runRuleTypeAsync(config, eRuleType.visibility, ruleArgs)
                ).then(() => {
                    this.$scope.visiblePages = config.pages.filter((p) => p.visible);
                    if (!this.$scope.model.idWorkflow &&
                        this.$scope.defConfig.hasQuoteRule
                    ) {
                        // run the quote rule if we are not in a workflow 
                        // (in a workflow it get's run the by the action on the server)
                        this.$scope.model.headerValues = this.$scope.defConfig.getConfiguredProduct();
                        return this.api.quotes.runQuoteHeaderRule(
                            this.$scope.model,
                            this.$rootScope.contentTracker
                        ).then(q => {
                            this.setUpdatedModelInternal(q, false);
                        });
                    }
                });

        return runRules;
    }

    public getRuleArgs(config: Configurator, changedField?: Field): QuoteHeaderRuleArgs {
        let ruleArgs = new QuoteHeaderRuleArgs(this);
        ruleArgs.user = this.$rootScope.user;
        ruleArgs.environment = this.$rootScope.environment;
        ruleArgs.baseUrl = this.$rootScope.context.baseUrl;
        ruleArgs.configurator = config;
        ruleArgs.kom = config.$manager;
        ruleArgs.parentKom = config.$parentConfigurator ? config.$parentConfigurator.$manager : null;
        ruleArgs.changedField = changedField;
        ruleArgs.quote = this.$scope.model;
        ruleArgs.logs = new ClientLogger();
        ruleArgs.clientLanguage = this.$rootScope.clientLanguage;
        if (this.$rootScope.context.sfdcCanvasRequest) {
            // combine query string parameters with sfdc parameters
            ruleArgs.parameters = Utils.extend(
                this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters,
                this.$location.search()
            );
        } else {
            ruleArgs.parameters = this.$location.search();
        }

        return ruleArgs;
    }

    /**
     * starts a configurator by loading any tables it references and running the rules once
     * @param config
     */
    public startConfigurator(): ng.IPromise<any> {
        let tableIds = this.header.references.filter(r => r.type.isEqual("Table")).map(r => r.id);
        return this.helper.downloadTables(tableIds)
            .then(() => this.runRuleCycleUnit(this.$scope.defConfig, null));
    }

    private startValidationTimer() {
        if (!this._stopValidationTimer) {
            this._stopValidationTimer = this.$interval(() => {
                this.validate();
            }, 1000);
        }
    }

    private stopValidationTimer() {
        this.$interval.cancel(this._stopValidationTimer);
        this._stopValidationTimer = null;
    }

    public handleActionResponse(result: IQuote, actionType: string) {
        this.setUpdatedModelInternal(result, false);
        if (
            actionType == eWorkflowAction.submit
            && !this.$rootScope.isSfdc
            && !result.allowedActions.some(a => a.type == eWorkflowAction.modifyProducts) //only clear the active quote if the user no longer has modify product permissions
        ) {
            this.quoteService.quote = null;
        } else {
            // if this is the active quote, then refresh the active quote data to keep it in sync
            if (this.quoteService.quote && result && this.quoteService.quote.id === result.id) {
                this.quoteService.quote = result;
            }
        }
        if (this.$scope.isNew) { // change to edit edit screen if we were on the new screen before
            this.quoteService.quote = result;
            this.$state.go("kb.quoteEdit", { id: this.$scope.model.id });
        } else {
            this.refreshDrawers();
        }

        // refresh the comments as sometimes they are added server-side (like for rejection reasons)
        this.$scope.commentListApi.refresh();
        this.refreshPermissions();
        this.validate();
        this.markChangesClean();
    }

    private revertToClean() {
        this.setUpdatedModelInternal(angular.copy(this.cleanModel), false);
    }

    private promptUserToFixErrors() {
        this.dialogService.alert({ type: eAlertType.error, template: Dirs.view("alert-quote-errors") });
    }

    public runValidationRule(config: Configurator, ruleArgs: IConfiguratorRuleArgs): ng.IPromise<any> {
        config.preValidate(); // call internal validation for fields
        return this.helper.runRuleTypeAsync(config, eRuleType.validation, ruleArgs).then(() => {
            config.isValid(); //force recalculation of $valid property
        });
    }
}
